import { api } from "@/lib/api";
import { toast } from "sonner";

/**
 * Download the PDF receipt for a completed transaction and save it locally.
 * Called from the success handlers of transfer/deposit/withdraw, and from
 * the receipt button on the Transactions list.
 */
export async function downloadReceipt(txId, opts = {}) {
  if (!txId) {
    toast.error("Missing transaction reference.");
    return false;
  }
  try {
    const res = await api.get(`/wallet/receipt/${txId}`, {
      responseType: "blob",
    });
    const blob = res.data instanceof Blob ? res.data : new Blob([res.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `FinVault-Receipt-${txId}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    if (!opts.silent) toast.success("Receipt downloaded.");
    return true;
  } catch (e) {
    console.error("receipt download failed", e);
    if (!opts.silent) toast.error("Couldn't download receipt.");
    return false;
  }
}
